<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <span v-on="on">{{ summary }}</span>
    </template>
    <div>{{ detail }}</div>
  </v-tooltip>
</template>
<script>
import { unixtimeToFormattedTime } from "@/utils/datetime.js";

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    summary: "",
    detail: "",
  }),
  mounted() {
    this.setSummaryAndDetail();
  },
  watch: {
    items() {
      this.setSummaryAndDetail();
    },
  },
  methods: {
    setSummaryAndDetail() {
      let summary = "";
      let detail = "";

      this.items.forEach((item) => {
        if (item.time && item.time > 0) {
          const row =
            item.client_name.replace("株式会社", "").replace("有限会社", "") +
            ":" +
            unixtimeToFormattedTime(item.time);
          summary += row + ", ";
          detail += row + " | ";
        } else if (item.price && item.price > 0) {
          const row =
            item.client_id +
            item.client_name.replace("株式会社", "").replace("有限会社", "") +
            ": ¥" +
            item.price;
          summary += row + ", ";
          detail += row + " | ";
        }
      });
      summary = summary.slice(0, -2); //最後の", "を削除
      detail = detail.slice(0, -3); //最後の"¥n"を削除
      this.summary =
        summary.length >= 30 ? summary.slice(0, 29) + "..." : summary;
      this.detail = detail;
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  border-collapse: collapse;
  border-spacing: 0;
  background-color: white;
  th,
  td {
    border: solid 1px;
    padding: 5px;
  }
}
</style>